import AssistantBulkActionsAPI from 'dashboard/api/assistant/bulkActions';
import { createStore } from '../storeFactory';
import { throwErrorMessage } from 'dashboard/store/utils/api';

export default createStore({
  name: 'AssistantBulkAction',
  API: AssistantBulkActionsAPI,
  actions: mutations => ({
    processBulkAction: async function processBulkAction(
      { commit },
      { type, actionName, ids }
    ) {
      commit(mutations.SET_UI_FLAG, { isUpdating: true });
      try {
        const response = await AssistantBulkActionsAPI.create({
          type,
          action_name: actionName,
          ids,
        });
        commit(mutations.SET_UI_FLAG, { isUpdating: false });
        return response.data;
      } catch (error) {
        commit(mutations.SET_UI_FLAG, { isUpdating: false });
        return throwErrorMessage(error);
      }
    },

    handleBulkDelete: async function handleBulkDelete(
      { dispatch },
      { type = 'response', ids }
    ) {
      const response = await dispatch('processBulkAction', {
        type,
        actionName: 'delete',
        ids,
      });

      if (type === 'response') {
        await dispatch('assistantResponses/removeBulkResponses', ids, {
          root: true,
        });
      } else if (type === 'document') {
        await dispatch('assistantDocuments/removeBulkRecords', ids, {
          root: true,
        });
      }
      return response;
    },

    handleBulkApprove: async function handleBulkApprove({ dispatch }, ids) {
      const response = await dispatch('processBulkAction', {
        type: 'response',
        actionName: 'approve',
        ids,
      });

      await dispatch('assistantResponses/updateBulkResponses', response, {
        root: true,
      });
      return response;
    },
  }),
});
